const OrdersData = [
    {
        CourierId: "2210",
        PickUpAddress: "New Delhi",
        PickUpTime: "23-04-2022",
        DropAddress: "Hyderabad",
        DropTime:"24-04-2022",
        Status:"In transit",

    },{
        CourierId: "1585",
        PickUpAddress: "Agra",
        PickUpTime: "23-04-2022",
        DropAddress: "Mumbai",
        DropTime:"24-04-2022",
        Status:"Picked Up",
    },{
        CourierId: "1147",
        PickUpAddress: "Bengaluru",
        PickUpTime: "23-04-2022",
        DropAddress: "Pune",
        DropTime:"24-04-2022",
        Status:"Delivered",
    },
];

export default OrdersData;